import { useHistory } from "react-router";
import { ArrowLeft, VipBadge } from "../svg";
import { PlayerBuyPackageButtonProps } from "./player.buy.package.button.props";

export const PlayerBuyPackageButton: React.FC<PlayerBuyPackageButtonProps> = ({
  player,
  hasLockStram,
  hasLockSub,
  packageId,
  programId,
  programTitle,
}) => {
  //#region dependencies

  const { goBack } = useHistory();

  //#endregion

  //#region methods

  const onClick = () => {
    // packageId && push(`/subscription/${packageId}/${programId}`);
    player.exitFullScreen();
    goBack();
  };

  //#endregion

  return (
    <div
      className="d-flex align-items-center buy-package-button rtl "
      style={{ justifyContent: "space-between" }}
    >
      <div>
        <span
          className="buy-package-button__icon"
          style={{ marginLeft: "32px" }}
        >
          {programTitle}
        </span>
      </div>
      <div
        className="buy-package-button__button d-sm-flex align-items-center mr-auto d-none selectableItem"
        onClick={onClick}
      >
        <ArrowLeft width="72" height="72" />
      </div>
    </div>
  );
};
